'use client'

import { type FC } from 'react'

import { NextLink, type NextLinkProps } from '../../../next-link'
import { useWebviewContext } from '../../../webview'

type StoryblokProductBatteryLinkProps = Omit<NextLinkProps, 'href'> & {
  href: string
}

export const StoryblokProductBatteryLink: FC<
  StoryblokProductBatteryLinkProps
> = ({ children, ...rest }) => {
  const webview = useWebviewContext()

  if (webview) {
    return <a {...rest}>{children}</a>
  }

  return <NextLink {...rest}>{children}</NextLink>
}
